export default __webpack_public_path__ + "static/Florida-dad8727d73561a94763f61d6e52e54b6.webp";